module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"no_orders_to_review":"投稿可能な注文がありません。","confirm_cancel_review":"レビューの作成をキャンセルしますか？今キャンセルすると、入力した内容がすべて削除されます。"}}')
  delete Component.options._Ctor
}
